<h1 class="sr-only"><span>PREMIOS SORTEO ANÁHUAC MAGNO 2026</span></h1>
<section class="stc-premios">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 text-center p-0">


        <div class="custom-slider-container">
          <ngb-carousel #carousel1 [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0">

            <ng-template ngbSlide id="c1-0">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio1.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">EDO. MÉXICO</h1>
                    <h3 class="subtitle-place">Blue Bosque Real</h3>
                    <p class="description">Departamento Amueblado</p>
                    <span class="price">Valor + de <strong>12.5 MILLONES</strong></span>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-1">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio2.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">CANCÚN</h1>
                    <h3 class="subtitle-place">Residencial Mar</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-2">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio3.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">MÉRIDA</h1>
                    <h3 class="subtitle-place">Yucatán Country</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-3">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio4.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">PUEBLA</h1>
                    <h3 class="subtitle-place">Lomas de Angelópolis</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-4">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio5.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">QUERÉTARO</h1>
                    <h3 class="subtitle-place">El Campanario</h3>
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-carousel>

          <div class="slider-controls-wrapper">
            <button (click)="carousel1.prev()" class="btn-nav"><i class="fas fa-chevron-left"></i></button>
            <button (click)="carousel1.next()" class="btn-nav"><i class="fas fa-chevron-right"></i></button>
          </div>

          <div class="thumbnails-overlay">
            <div class="thumb-card" (click)="carousel1.select('c1-0')" [class.active]="carousel1.activeId === 'c1-0'">
              <img src="assets/images/sorteo2026/banner-premio1.jpg" alt="Edo México">
              <div class="thumb-info"><span class="rank">1°</span> <span class="name">EDO. MÉX.</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-1')" [class.active]="carousel1.activeId === 'c1-1'">
              <img src="assets/images/sorteo2026/banner-premio2.jpg">
              <div class="thumb-info"><span class="rank">2°</span> <span class="name">CANCÚN</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-2')" [class.active]="carousel1.activeId === 'c1-2'">
              <img src="assets/images/sorteo2026/banner-premio3.jpg">
              <div class="thumb-info"><span class="rank">3°</span> <span class="name">MÉRIDA</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-3')" [class.active]="carousel1.activeId === 'c1-3'">
              <img src="assets/images/sorteo2026/banner-premio4.jpg">
              <div class="thumb-info"><span class="rank">4°</span> <span class="name">PUEBLA</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-4')" [class.active]="carousel1.activeId === 'c1-4'">
              <img src="assets/images/sorteo2026/banner-premio5.jpg">
              <div class="thumb-info"><span class="rank">5°</span> <span class="name">QUERÉTARO</span></div>
            </div>
          </div>
        </div>

        <br><br>

        <div class="custom-slider-container">
          <ngb-carousel #carousel2 [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0">

            <ng-template ngbSlide id="c2-0">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio6.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">AUDI</h1>
                    <h3 class="subtitle-place">Q7 - Luxury Edition</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c2-1">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio7.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">MINI COOPER</h1>
                    <h3 class="subtitle-place">Serie 3</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c2-2">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio8.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">KIA</h1>
                    <h3 class="subtitle-place">k3</h3>
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-carousel>

          <div class="slider-controls-wrapper">
            <button (click)="carousel2.prev()" class="btn-nav"><i class="fas fa-chevron-left"></i></button>
            <button (click)="carousel2.next()" class="btn-nav"><i class="fas fa-chevron-right"></i></button>
          </div>

          <div class="thumbnails-overlay">
            <div class="thumb-card" (click)="carousel2.select('c2-0')" [class.active]="carousel2.activeId === 'c2-0'">
              <img src="assets/images/sorteo2026/banner-premio6.jpg">
              <div class="thumb-info"><span class="rank">6°</span> <span class="name">AUDI</span></div>
            </div>

            <div class="thumb-card" (click)="carousel2.select('c2-1')" [class.active]="carousel2.activeId === 'c2-1'">
              <img src="assets/images/sorteo2026/banner-premio7.jpg">
              <div class="thumb-info"><span class="rank">7°</span> <span class="name">MINI Cooper</span></div>
            </div>

            <div class="thumb-card" (click)="carousel2.select('c2-2')" [class.active]="carousel2.activeId === 'c2-2'">
              <img src="assets/images/sorteo2026/banner-premio8.jpg">
                 <div class="w-75 thumb-info d-flex flex-column text-center"><span class="rank">8°-12°</span> <span class="name">KIA K3</span></div>
            </div>
          </div>
        </div>


        <div class="custom-slider-container mt-5">
          <ngb-carousel #carousel3 [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0">

            <ng-template ngbSlide id="c3-0">
              <div class="main-slide"
                [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio13-22.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">MACBOOK AIR</h1>
                    <h3 class="subtitle-place">13 pulgadas - Chip M3</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-1">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio23-32.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">IPHONE 17</h1>
                    <h3 class="subtitle-place">Cámara Pro de 48MP</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-2">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio33-42.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">IPAD AIR</h1>
                    <h3 class="subtitle-place">Pantalla Liquid Retina</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-3">
              <div class="main-slide"
                [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio43-56.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">AIRPODS MAX</h1>
                    <h3 class="subtitle-place">Audio Espacial Personalizado</h3>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-4">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/banner-premio57-475.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <h1 class="title-city">APPLE WATCH SE</h1>
                    <h3 class="subtitle-place">Tu compañero de salud</h3>
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-carousel>

          <div class="slider-controls-wrapper">
            <button (click)="carousel3.prev()" class="btn-nav"><i class="fas fa-chevron-left"></i></button>
            <button (click)="carousel3.next()" class="btn-nav"><i class="fas fa-chevron-right"></i></button>
          </div>

          <div class="thumbnails-overlay">

            <div class="thumb-card" (click)="carousel3.select('c3-0')" [class.active]="carousel3.activeId === 'c3-0'">
              <img src="assets/images/sorteo2026/banner-premio13-22.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">13°-22°</span> <span class="name">MACBOOK AIR</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-1')" [class.active]="carousel3.activeId === 'c3-1'">
              <img src="assets/images/sorteo2026/banner-premio23-32.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">23°-32°</span> <span class="name">IPHONE 17</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-2')" [class.active]="carousel3.activeId === 'c3-2'">
              <img src="assets/images/sorteo2026/banner-premio33-42.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">33°-42°</span> <span class="name">IPAD AIR</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-3')" [class.active]="carousel3.activeId === 'c3-3'">
              <img src="assets/images/sorteo2026/banner-premio43-56.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">43°-56°</span> <span class="name">AIRPODS MAX</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-4')" [class.active]="carousel3.activeId === 'c3-4'">
              <img src="assets/images/sorteo2026/banner-premio57-475.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">57°-475°</span> <span class="name">WATCH SE</span></div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</section>


<!-- <section class="content-aw">
  <div class="container">
    <div class="row">

      <div class="col-12 text-center">
        <h1 class="title">
          <span class="highlight">¡DÉJATE </span>
          <span class="outline">SORPRENDER </span>
          <br>
          <span class="highlight">CON SORTEO MAGNO!</span>
        </h1>
      </div>

      <div class="col-md-6 offset-md-1 text-md-right text-center">
        <img src="/assets/images/sorteo2025/premios/premio1.png" alt="Primer premio" class="img-fluid">
      </div>


      <div class="col-md-5 text-md-left text-center my-auto">
        <h3>Primer premio</h3>
        <p class="award-text">
          Departamento <span class="amueblado">amueblado</span> en Cancún
        </p>
        <p class="text-black">Valor más de 12.5 millones</p>
        <div class="mt-3">
          <p><span>Fecha del Sorteo: </span> <br> 20 de Noviembre 2025</p>
          <p><span>Sede:</span><br> Universidad Anáhuac Cancún</p>

          <div class="row mt-4">
            <div class="col-md-6">
              <img src="/assets/images/sorteo2025/premios/awards.png" class="img-fluid mt-3">
            </div>
            <div class="col-md-6">
              <img src="/assets/images/sorteo2025/premios/price.png" class="img-fluid mt-3">
            </div>
          </div>

          <a href="{{urlMicrositio}}" target="_blank" class="btn-stack mt-5">¡CÓMPRALO YA!</a>
        </div>
      </div>



      <div class="col-12 text-center bottom-award">
        <h4>
          DESCUBRE NUESTRAS NUEVAS
          SORPRESAS
        </h4>
        <p class="description mt-4">
          Más de <b>920 increíbles premios</b>! Exclusivas propiedades amuebladas,
          incluyendo un departamento en Cancún y otras 4 impresionantes ubicaciones.
          Además, tendrás la oportunidad de ganar el nuevo Kia K3 y productos Apple de última generación.
        </p>
      </div>


    </div>



  </div>
</section>






<section class="cta-magno">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <h5>
          <span>¡SÚMATE A</span> <br> SORTEO ANÁHUAC!
        </h5>

        <p>
          Y gana apoyando la educación de miles de
          alumnos de la Red de Universidades Anáhuac y
          creemos un mejor futuro para nuestro país.

        </p>
      </div>
    </div>
  </div>
</section>





<section class="stc-premios-list">
  <div class="container">
    <div class="row">


      <ng-container *ngIf="!isSmallScreen">
        <ng-container *ngFor="let image of premios; let i = index">
          <div *ngIf="i % 2 === 0" class="col-md-8">
            <div [id]="image.id" class="carousel slide" data-ride="false">
              <div class="carousel-inner">
                <div *ngFor="let img of image.imagenes; let first = first" class="carousel-item"
                  [ngClass]="{'active': first}">
                  <youtube-player [videoId]="img" [height]="400" [width]="'100%'">
                  </youtube-player>
                </div>
              </div>
              <a class="carousel-control-prev" [href]="'#' + image.id" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              </a>
              <a class="carousel-control-next" [href]="'#' + image.id" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
              </a>
            </div>
          </div>

          <div class="col-md-4 my-auto" [ngClass]="{'text-right': i % 2 !== 0}">
            <span class="number">{{ image.number }}</span>
            <h3 class="m-0">{{ image.title }}</h3>
            <h3 class="m-0"><strong>{{ image.subtitle }}</strong></h3>
            <p class="m-0">{{ image.place }}</p>
            <p class="m-0"><strong>{{ image.subplace }}</strong></p>
            <p class="m-0"><i>{{ image.price }}</i></p>
            <p>Precio del boleto: <span class="d-block strong">$500</span></p>

            <a href="{{urlMicrositio}}" target="_blank" class="btn-stack mt-3">¡COMPRA YA!</a>
          </div>

          <div *ngIf="i % 2 !== 0" class="col-md-8">
            <div [id]="image.id" class="carousel slide" data-ride="false">
              <div class="carousel-inner">
                <div *ngFor="let img of image.imagenes; let first = first" class="carousel-item"
                  [ngClass]="{'active': first}">
                  <youtube-player [videoId]="img" [height]="400" [width]="'100%'">
                  </youtube-player>
                </div>
              </div>
              <a class="carousel-control-prev" [href]="'#' + image.id" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              </a>
              <a class="carousel-control-next" [href]="'#' + image.id" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
              </a>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="isSmallScreen">
        <ng-container *ngFor="let image of premios; let i = index">
          <div class="col-12 col-md-4 my-auto">
            <span class="number">{{ image.number }}</span>
            <h3 class="m-0">{{ image.title }}</h3>
            <h3 class="m-0"><strong>{{ image.subtitle }}</strong></h3>
            <p class="m-0">{{ image.place }}</p>
            <p class="m-0"><strong>{{ image.subplace }}</strong></p>
            <p class="m-0"><i>{{ image.price }}</i></p>
            <p>Precio del boleto: <span>$500</span></p>
            <a class="btn-stack mt-3">¡COMPRA YA!</a>
          </div>

          <div class="col-12 col-md-8">
            <div [id]="image.id" class="carousel slide" data-ride="false">
              <div class="carousel-inner">
                <div *ngFor="let img of image.imagenes; let first = first" class="carousel-item"
                  [ngClass]="{'active': first}">
                  <youtube-player [videoId]="img" [height]="400" [width]="'100%'">
                  </youtube-player>
                </div>
              </div>
              <a class="carousel-control-prev" [href]="'#' + image.id" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              </a>
              <a class="carousel-control-next" [href]="'#' + image.id" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
              </a>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <div class="col-md-8 offset-md-2 text-center my-auto">
        <img src="/assets/images/sorteo2025/premios/premio6.png" class="img-fluid mt-5">
        <img src="/assets/images/sorteo2025/premios/premio7.png" class="img-fluid mt-5">
      </div>




    </div>
  </div>
</section> -->